// extracted by mini-css-extract-plugin
export default {"root":"ArticleForm_root__yL43Q","sidebar":"ArticleForm_sidebar__mqWlg","form":"ArticleForm_form__ZUwEQ","content":"ArticleForm_content__t8fQ2"};